<template>
    <div>
        <Separator
            :label="getSectionTitle"
            :label-link="getLabelLink"
            :link="getProjectLink"
            class="margin_bottom_60"
        />
        <template v-if="linkedEvents">
            <event-slider :events="linkedEvents" v-if="linkedEvents.length > 1"/>
            <div class="container-fluid__with-padding-x margin_bottom_60" v-else>
                <div class="row justify-content-center">
                    <div class="col-12 text-center">
                        <div class="d-inline-block">
                            <event-slide
                                v-if="linkedEvents[0].cover && linkedEvents[0].cover.cached_url"
                                class=""
                                :event="linkedEvents[0]"
                                :image="linkedEvents[0].cover.cached_url"
                                :isSingle="true"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>

</template>

<script>
import Separator from './Separator'
import EventSlider from "./EventSlider";
import EventSlide from "./EventSlide";
import {mapGetters} from "vuex";

export default {
    name: "LinkedEvent",
    components: {
        Separator,
        EventSlider,
        EventSlide
    },
    props: {
        events: null,
        forProject: false,
        forPeople: false,
    },
    computed: {
        ...mapGetters('event', {
            thumbnail: 'getEventThumbnail'
        }),
        linkedEvents() {
            return this.forPeople ? this.events : this.events.linked_events
        },
        hasProject() {
            return this.forPeople ? false : this.events.project
        },
        getSectionTitle() {
            return this.forProject ? this.$t('page.linked_events_project') :
                    (this.hasProject ? this.$t('page.linked_events_parent') : this.$t('page.linked_events'))
        },
        getProjectLink() {
            return this.forProject ? null : this.hasProject ? {
                name: 'project.view',
                params: {id: this.hasProject.id, slug: this.hasProject.slug}
            } : null
        },
        getLabelLink() {
            return this.forProject ? null : this.hasProject ? this.hasProject.title : ''
        }

    }
}
</script>

